import React, { useEffect } from 'react'
import styled from 'styled-components'
import { MovieItem } from './MovieItem'
import { useDispatch, useSelector } from 'react-redux'
import { selectMovies, selectMoviesStateStatus } from '../reducers/movies/selectors'
import { loadMovies } from '../reducers/movies/dispatchers'

const Container = styled.div`
  display: grid;
  justify-content: center;
  background-color: #f1efe4;
`

const ListContainer = styled.div`
  width: 100vw;
  max-width: 500px;
  height: 100vh;
  overflow-y: scroll;
  display: grid;
  gap: 2px;
  align-content: start;
`

export const MoviesList = (): JSX.Element => {
  const dispatch = useDispatch()
  const moviesStateStatus = useSelector(selectMoviesStateStatus)
  const movies = useSelector(selectMovies)

  useEffect(() => {
    void dispatch(loadMovies())
  }, [dispatch])

  return (<>{moviesStateStatus === 'loaded' &&
    <Container>
      <ListContainer>
        {movies?.map(x => <MovieItem key={x.id} {...x} />)}
      </ListContainer>
    </Container>
    }
  </>)
}
